
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Shape')]),_c('g',{attrs:{"id":"Screens","stroke":"none","stroke-width":"1","fill":"currentColor","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"If-Else--Copy","transform":"translate(-1033.000000, -977.000000)","fill":"#8492A6","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(950.000000, 970.000000)"}},[_c('g',{attrs:{"id":"Group-11-Copy","transform":"translate(76.000000, 0.000000)"}},[_c('g',{attrs:{"id":"maximize-area","transform":"translate(7.000000, 7.000000)"}},[_c('path',{attrs:{"d":"M16,10 L16,15 C16,15.6 15.6,16 15,16 L10,16 L10,14 L14,14 L14,10 L16,10 Z M2,10 L2,14 L6,14 L6,16 L1,16 C0.4,16 0,15.6 0,15 L0,10 L2,10 Z M6,0 L6,2 L2,2 L2,6 L0,6 L0,1 C0,0.4 0.4,0 1,0 L6,0 Z M15,0 C15.6,0 16,0.4 16,1 L16,6 L14,6 L14,2 L10,2 L10,0 L15,0 Z","id":"Shape"}})])])])])])])
          )
        }
      }
    